// Mo'Stò — localStorage wishlist
(function() {
  const KEY = 'mosto_wishlist_v1';

  const get = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };
  const save = (arr) => localStorage.setItem(KEY, JSON.stringify([...new Set(arr)]));

  const isIn = (id) => get().includes(String(id));
  const toggle = (id) => {
    const arr = get();
    const i = arr.indexOf(String(id));
    if (i >= 0) arr.splice(i, 1); else arr.push(String(id));
    save(arr);
    document.dispatchEvent(new CustomEvent('mosto:wishlist:change', { detail: { id, list: arr } }));
    return arr.indexOf(String(id)) >= 0;
  };
  const count = () => get().length;

  // Apply heart state to all wishlist buttons on page
  function refreshButtons() {
    document.querySelectorAll('[data-mosto-wishlist]').forEach(btn => {
      const id = btn.dataset.mostoWishlist;
      const active = isIn(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Rimuovi dalla wishlist' : 'Aggiungi alla wishlist');
    });
    // Header counter
    document.querySelectorAll('[data-mosto-wishlist-count]').forEach(el => {
      const c = count();
      el.textContent = c > 0 ? c : '';
      el.style.display = c > 0 ? 'inline-flex' : 'none';
    });
  }

  // Bind clicks
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mosto-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.mostoWishlist);
    refreshButtons();
    // Burst animation
    btn.classList.add('is-burst');
    setTimeout(() => btn.classList.remove('is-burst'), 600);
  });

  // Render wishlist page
  const wishlistPage = document.getElementById('MostoWishlistContainer');
  if (wishlistPage) {
    const renderPage = async () => {
      const ids = get();
      if (ids.length === 0) {
        wishlistPage.innerHTML = `
          <div class="wishlist-mosto__empty">
            <span class="wishlist-mosto__empty-icon">🤍</span>
            <h2>La tua wishlist è vuota</h2>
            <p>Aggiungi i prodotti che ami al tuo cuore. Ti aspetteranno qui per dopo.</p>
            <a href="/collections/all" class="wishlist-mosto__cta">Esplora i prodotti →</a>
          </div>`;
        return;
      }
      wishlistPage.innerHTML = '<p class="wishlist-mosto__loading">Carico la tua wishlist...</p>';
      const products = [];
      for (const id of ids) {
        try {
          const handle = id.startsWith('handle:') ? id.replace('handle:', '') : null;
          const url = handle ? `/products/${handle}.js` : `/products.json?ids=${id}`;
          const r = await fetch(url);
          if (!r.ok) continue;
          const data = await r.json();
          products.push(handle ? data : data.product);
        } catch {}
      }
      if (products.length === 0) {
        wishlistPage.innerHTML = '<p class="wishlist-mosto__empty">Wishlist non disponibile.</p>';
        return;
      }
      const html = `<div class="wishlist-mosto__grid">${products.filter(Boolean).map(p => `
        <article class="wishlist-mosto__card">
          <a href="${p.url || ('/products/' + p.handle)}" class="wishlist-mosto__media">
            ${p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}" loading="lazy">` : ''}
          </a>
          <button class="wishlist-mosto__remove" data-mosto-wishlist="handle:${p.handle}" aria-label="Rimuovi">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7-4.5-9.5-9.5C.5 7.5 3.5 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 3.5 0 6.5 3.5 4.5 7.5C19 16.5 12 21 12 21z"/></svg>
          </button>
          <div class="wishlist-mosto__body">
            <a href="${p.url || ('/products/' + p.handle)}"><h3>${p.title}</h3></a>
            <p class="wishlist-mosto__price">€${(p.price/100).toFixed(2)}</p>
            <a href="${p.url || ('/products/' + p.handle)}" class="wishlist-mosto__view">Vedi prodotto →</a>
          </div>
        </article>
      `).join('')}</div>`;
      wishlistPage.innerHTML = html;
      refreshButtons();
    };
    renderPage();
    document.addEventListener('mosto:wishlist:change', renderPage);
  }

  // Initial pass
  document.addEventListener('DOMContentLoaded', refreshButtons);
  refreshButtons();
})();
